var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.workingApplication.personalDetails !== undefined
    ? _c("span", [
        _vm._v("\n  Χρήστης:\n  "),
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.workingApplication.personalDetails.name) +
              "\n    " +
              _vm._s(_vm.workingApplication.personalDetails.surname) +
              ",\n  "
          )
        ]),
        _c("br"),
        _vm._v("\n  Τύπος:\n  "),
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.applicationTypeDescription(
                  _vm.workingApplication.applicationType,
                  _vm.workingApplication.reappraisalSecondDegree
                )
              ) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v(_vm._s(_vm.translate(_vm.workingApplication.degreeType)))
        ]),
        _vm._v(" "),
        _vm.workingApplication.degreeType === "bachelor"
          ? _c("span", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.workingApplication.correspondence
                      ? " με Ακαδημαϊκή Ισοδυναμία"
                      : " "
                  ) +
                  "\n  "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.workingApplication.degreeType === "bachelor"
          ? _c("span", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.workingApplication.consideration
                      ? "με Συνυποβολή τίτλου 2ου κύκλου σπουδών"
                      : "χωρίς Συνυποβολή"
                  ) +
                  "\n  "
              )
            ])
          : _vm._e(),
        _c("br"),
        _vm._v(" "),
        _vm.workingApplication.protocol !== null
          ? _c("span", [
              _vm._v("\n     Αριθμός Πρωτοκόλλου:\n    "),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.workingApplication.protocol) +
                    "\n    "
                )
              ])
            ])
          : _c(
              "span",
              { staticStyle: { "font-weight": "bold", color: "red" } },
              [
                _c("br"),
                _vm._v(
                  "Προσοχή: Η αίτηση δεν έχει αριθμό πρωτοκόλλου. Θα οριστεί αυτόματα κατά την οριστική υποβολή της από τον προέλεγχο.\n  "
                )
              ]
            ),
        _vm._v(" "),
        _vm.workingApplication.praxeisNo !== null
          ? _c("span", [
              _vm._v("\n    , Αριθμός Πράξης:\n    "),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.workingApplication.praxeisNo) +
                    "\n    "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.recognized
          ? _c("span", [
              _vm._v("\n    , Ημερομηνία Αναγνώρισης:\n    "),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("\n        " + _vm._s(_vm.dateRecognized) + "\n    ")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.received
          ? _c("span", [
              _vm._v("\n    , Ημερομηνία Παραλαβής:\n    "),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("\n        " + _vm._s(_vm.dateReceived) + "\n    ")
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16f69bfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16f69bfa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UserAppInfo.vue
// module id = null
// module chunks = 